// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0a8e754c","453":"66079093","455":"7d349c72"}[chunkId] + ".chunk.js";
};